import { TOverviewCriterionStatus } from "@/zapi-frontend/stores/project";

export const SHADOW_200 =
  "shadow-[0px_51px_14px_0px_rgba(24,24,27,0),0px_33px_13px_0px_rgba(24,24,27,0),0px_18px_11px_0px_rgba(24,24,27,0.01),0px_8px_8px_0px_rgba(24,24,27,0.01),0px_2px_5px_0px_rgba(24,24,27,0.02)]";

export const STATUS_ORDER: TOverviewCriterionStatus[] = ["pass", "conditional", "fail", "unvalidated", "not_defined"];
